import { render, staticRenderFns } from "./project.vue?vue&type=template&id=417ab35e&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417ab35e",
  null
  
)

export default component.exports